import {http} from '../util/http'
import {API_DOMAIN, API_KOTLIN_DOMAIN} from '../config'
import headers from './employeeSystemHeader'
import {fetchData, postData} from "../util"
import {AxiosPromise} from "axios"

// (旧）桌台列表
export const fetchWalletBillList = (params) => {
    return http({
        headers: headers(),
        url: `${API_DOMAIN}/Manage/WalletApi/WalletRecord`,
        params,
    })
}

//(新）
/**
 * 获取会员记录
 * @param page 页码
 * @param count 每页数量
 * @param keyword 关键字
 * @param keywordType 关键字类型
 * @param discountId 折扣id
 * @returns {AxiosPromise}
 */
export const getClubMemberList = (page, count, keyword, keywordType, discountId) => {
    const params = {
        page,
        count,
    }
    if (keyword) {
        params.keyword = keyword
    }
    if (keywordType) {
        params.keywordType = keywordType
    }
    if (discountId) {
        params.discountId = discountId
    }
    const clubId = sessionStorage.getItem('club_id')
    return http({
        headers: headers(clubId),
        url: `${API_KOTLIN_DOMAIN}/member`,
        params,
    })
}

/**
 * 获取会员折扣列表
 * @returns {AxiosPromise}
 */

export const getDiscountList = () => {
    const clubId = sessionStorage.getItem('club_id')
    return http({
        headers: headers(clubId),
        url: `${API_KOTLIN_DOMAIN}/business-club/discount`,
    })
}

/**
 * 修改手机号
 * @param accountId 会员id
 * @param newAccount 新手机号
 * @returns {Promise<unknown>}
 */
export const changePhone = (accountId, newAccount) => {
    const res = {
        accountId,
        newAccount
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/UpdateAccount`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 获取会员钱包
 * @param accountId 会员id
 * @returns {Promise<unknown>}
 */
export const getWalletList = (accountId) => {

    const endpoint = `${API_DOMAIN}/MemberApi/UserWalletInfo/account_id/${accountId}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 获取会员钱包记录
 * @param accountId 会员id
 * @param walletId 钱包id
 * @param page 页码
 * @returns {Promise<unknown>}
 */
export const getWalletRecord = (accountId, walletId, page) => {
    const res = {
        account_id: accountId,
        wallet_id: walletId,
        p: page,
    }
    const endpoint = `${API_DOMAIN}/Home/WalletApi/WalletRecord`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })

}

/**
 * 获取钻石记录
 * @param memberId 会员id
 * @param page 页码
 * @returns {Promise<unknown>}
 */
export const getDiamondRecord = (memberId, page) => {
    const res = {
        account_id: memberId,
        p: page,
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DiamondRecord`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 减少钱包金额
 * @param accountId 会员id
 * @param walletId 钱包id
 * @param decAmount 减少金额
 * @param reason 原因
 */
export const decWallet = (accountId, walletId, decAmount, reason) => {
    const res = {
        account_id: accountId,
        wallet_id: walletId,
        wallets: decAmount,
        reason: reason
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DecWallet`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 获取会员俱乐部等级折扣
 * @param accountId 会员id
 * @returns {AxiosPromise}
 */
export function getMemberClubLevel(accountId) {
    const params = {
        accountId
    }
    const clubId = sessionStorage.getItem('club_id')
    return http({
        headers: headers(clubId),
        url: `${API_KOTLIN_DOMAIN}/member/discount/member`,
        params,
    })
}

/**
 * 获取会员俱乐部等级折扣修改记录
 * @param queryParams 会员id
 * @returns {AxiosPromise}
 */
export function getMemberClubLevelRecord(queryParams) {
    const clubId = sessionStorage.getItem('club_id')
    return http({
        headers: headers(clubId),
        url: `${API_KOTLIN_DOMAIN}/member/discount/journal`,
        params: {
            ...queryParams
        },
    })
}


/**
 * 获取会员足迹结账记录
 * @param memberId 会员id
 * @param page 页码
 * @returns {Promise<unknown>}
 */
export const getClubMemberTrackBill = (memberId, page) => {
    const endpoint = `${API_DOMAIN}/Home/FootprintApi/FootBill/account_id/${memberId}/p/${page}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 获取会员足迹购买记录
 * @param memberId 会员id
 * @param page 页码
 * @returns {Promise<unknown>}
 */
export const getClubMemberTrackBuy = (memberId, page) => {
    const endpoint = `${API_DOMAIN}/Home/FootprintApi/FootBuy/account_id/${memberId}/p/${page}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 获取会员足迹奖金记录
 * @param memberId 会员id
 * @param page 页码
 * @returns {Promise<unknown>}
 */
export const getClubMemberTrackBound = (memberId, page) => {
    const endpoint = `${API_DOMAIN}/Home/FootprintApi/FootLottery/account_id/${memberId}/p/${page}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}
/**
 * 获取会员足迹奖金记录详情
 * @param sn 序列号
 * @returns {Promise<unknown>}
 */
export const getClubMemberTrackBoundDetail = (sn) => {
    const endpoint = `${API_DOMAIN}/FootprintApi/FootDetailed/sn/${sn}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 获取会员足迹常购商品记录
 * @param memberId
 * @returns {Promise<unknown>}
 */
// TODO page写死了，这个功能用的不多，而且后端返回的count有误也是写死的，做不了分页
export const getClubMemberTrackWeekly = (memberId) => {
    const endpoint = `${API_DOMAIN}/Home/FootprintApi/FootWeekly/account_id/${memberId}/p/1`
    return fetchData(endpoint).then((data) => {
        return data
    })
}


/**
 * 获取会员结账记录详情
 * @param sn 序列号
 * @returns {Promise<unknown>}
 */
export const getClubMemberTrackBillDetail = (sn) => {
    const endpoint = `${API_DOMAIN}/Home/BusinessApi/RecordDetails/sn/${sn}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 添加黑名單
 * @param accountId 会员id
 * @param reason 原因
 * @returns {Promise<unknown>}
 */
export const addBlackList = (accountId, reason) => {
    const res = {
        id: accountId,
        note: reason
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/AddBlack`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 删除黑名單
 * @param accountId 会员id
 * @returns {Promise<* | void>}
 */
export const deleteBlackList = (accountId) => {
    const res = {
        id: accountId,
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DeleteBlack`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 减少钻石数
 * @param accountId 会员id
 * @param diamond 减少钻石数
 * @param reason 原因
 * @returns {Promise<* | void>}
 */
export const decMemberDiamond = (accountId, diamond, reason) => {
    const res = {
        account_id: accountId,
        diamond: diamond,
        reason: reason
    }
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DecDiamond`
    return postData(endpoint, 'POST', JSON.stringify(res)).then((data) => {
        return data
    })
}

/**
 * 获取钻石数
 * @param memberId 会员id
 * @returns {Promise<unknown>}
 */
export const getMemberDiamond = (memberId) => {
    const endpoint = `${API_DOMAIN}/Home/MemberApi/DecDiamond/id/${memberId}`
    return fetchData(endpoint).then((data) => {
        return data
    })
}

/**
 * 获取会员折扣
 * @param memberId 会员id
 * @param levelId 等级id
 * @param clubId 俱乐部id
 * @returns {AxiosPromise}
 */
export const setDiscount = (memberId, levelId, clubId) => {
    const data = {
        levelId: levelId,
        memberId: memberId,
        originType: 3
    }
    return http({
        headers: headers(clubId),
        url: `${API_KOTLIN_DOMAIN}/member/discount/setDiscount`,
        data,
        method: 'post',
    })
}



// WEBPACK FOOTER //
// ./src/api/clubMemberList.js